import axios from 'axios'
import api from '@/api'

const patientsDiagnosis = {
  state: {
    data: []
  },
  getters: {
    getPatientsDiagnosis: state => state.data,
    getPatientsDiagnosisData: state => state.data.data_fields,
    getPatientsSpecializationDiagnosisData: state => state.data.specializations,
  },
  mutations: {
    PATIENT_DIAGNOSIS_GET (state, payload) {
      state.data = payload
    },
  },
  actions: {
    patientsDiagnosisGet (context) {
      axios({
        method: 'POST',
        url: `${api}patients/result-diagnosis/template`,
      }).then(response => {
        context.commit('PATIENT_DIAGNOSIS_GET', response.data);
      }).catch((error) => {
        console.log(error);
      })
    },
    patientsDiagnosisEditGet (context, value) {
      axios({
        method: 'POST',
        url: `${api}patients/result-diagnosis/item/` + value,
      }).then(response => {
        context.commit('PATIENT_DIAGNOSIS_GET', response.data);
      }).catch((error) => {
        console.log(error);
      })
    }
  }
};
export default patientsDiagnosis
